export type ImageAssetMeta = Pick<HTMLImageElement, 'width' | 'height'> & {
  srcSet: Pick<SrcSet, number | 'toString'>
}

export class SrcSet extends Array<string> {
  toString() {
    const [x1, x2, x3] = this.values()

    return `${x1}, ${[x2, x3].map((i, idx) => `${i} ${idx + 2}x`).join(', ')}`
  }
}
